import React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { IoMdRadioButtonOn } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import { IoMdTime } from "react-icons/io";
import { FaBagShopping } from "react-icons/fa6";
import { FaBox } from "react-icons/fa";
import { FaMapLocationDot } from "react-icons/fa6";
import { GoSearch } from "react-icons/go";
import { InprogressDelivery } from "./InProgress/inprogressDeliveries";
import { ClosedDelivery } from "./closedDeliveries";
import { NewDelivery } from "./newDeliveries";
import { useNavigate } from "react-router-dom";

const columns = [
  { id: "deliveryid", label: "DELIVERY ID", minWidth: 170, align: "center" },
  { id: "ryderid", label: "RYDER ID", minWidth: 170, align: "center" },
  { id: "pickup", label: "PICKUPLOCATION", minWidth: 200, align: "center" },
  { id: "drop", label: "DROP LOCATION", minWidth: 170, align: "center" },
  {
    id: "delivery",
    label: "DELIVERY SLOT TIME",
    minWidth: 170,
    align: "center",
  },
  { id: "typeofpack", label: "TYPE OF PACK", minWidth: 130, align: "center" },
  { id: "noofpack", label: "NO OF PACKS", minWidth: 130, align: "center" },
];

function createData(
  deliveryid,
  ryderid,
  pickup,
  drop,
  delivery,
  typeofpack,
  noofpack
) {
  return { deliveryid, ryderid, pickup, drop, delivery, typeofpack, noofpack };
}

const rows = [
  createData(
    "#AB1234",
    "#GMKDP123",
    "Shiva Sai Agencies",
    "Vasavi Traders",
    "10:30-11:00",
    "Bag",
    "04"
  ),
  createData(
    "#AB1234",
    "#GMKDP123",
    "Shiva Sai Agencies",
    "Vasavi Traders",
    "10:30-11:00",
    "Box",
    "04"
  ),
  createData(
    "#AB1234",
    "#GMKDP123",
    "Shiva Sai Agencies",
    "Vasavi Traders",
    "10:30-11:00",
    "Bag",
    "04"
  ),
  createData(
    "#AB1234",
    "#GMKDP123",
    "Shiva Sai Agencies",
    "Vasavi Traders",
    "10:30-11:00",
    "Box",
    "04"
  ),
  createData(
    "#AB1234",
    "#GMKDP123",
    "Shiva Sai Agencies",
    "Vasavi Traders",
    "10:30-11:00",
    "Bag",
    "04"
  ),
  createData(
    "#AB1234",
    "#GMKDP123",
    "Shiva Sai Agencies",
    "Vasavi Traders",
    "10:30-11:00",
    "Box",
    "04"
  ),
  createData(
    "#AB1234",
    "#GMKDP123",
    "Shiva Sai Agencies",
    "Vasavi Traders",
    "10:30-11:00",
    "Bag",
    "04"
  ),
];

export function ReallotedDelivery() {
  const navigate = useNavigate();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <div>
      <div className="delivery-top-container">
        <div className="admin-listText">List of Realloted Deliveries</div>
        <div>
          <select className="listAdmin-showRecords">
            <option>Show No of Records</option>
            <option>10</option>
            <option>25</option>
            <option>50</option>
            <option>100</option>
          </select>
        </div>
        <div className="search-container">
          <div className="nav-search ">
            <span className="search-icons">
              <GoSearch />
            </span>
            <input type="text" placeholder="Search"></input>
          </div>
        </div>
      </div>
      <div className="btnContainer">
        <button
          style={{
            // backgroundColor: "#FF961F",
            // color: "white",
            // display: "flex",
            backgroundColor: "#E8E8E9",
            color: "black",
            display: "flex",
          }}
          onClick={() => navigate("/out-for-delivery")}
        >
          <FaMapLocationDot style={{ marginRight: "8px" }} />
          Track Your Orders
        </button>
        <button
          style={{ backgroundColor: "#34C759", color: "white" }}
          onClick={() => navigate("/delivery")}
        >
          Unassigned
        </button>
        <button
          style={{ backgroundColor: "#FF961F", color: "white" }}
          onClick={() => navigate("/inprogress-delivery")}
        >
          {/* In Process */}
          Re-Assign
        </button>
        <button
          style={{ backgroundColor: "#E8E8E9" }}
          onClick={() => navigate("/closed-delivery")}
        >
          Closed
        </button>
        <button
          style={{ backgroundColor: "#1265C5", color: "white" }}
          onClick={() => navigate("/realloted-delivery")}
        >
          ReAlloted
        </button>
      </div>
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    className="table-header"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow
                    className="table-row"
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={index}
                    sx={{
                      backgroundColor: index % 2 === 1 ? "#E7F0F9" : "white",
                    }}
                  >
                    {columns.map((column) => {
                      const value = row[column.id];

                      return (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          className={`${column.id}-column tableCelldata`}
                          sx={{
                            color:
                              column.id === "status"
                                ? value === "Active"
                                  ? "green"
                                  : "red"
                                : "inherit",
                          }}
                        >
                          {column.id === "pickup" ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <IoMdRadioButtonOn
                                style={{ fontSize: "18px", color: "#34C759" }}
                              />
                              {value}
                            </div>
                          ) : column.id === "drop" ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <FaLocationDot
                                style={{ fontSize: "18px", color: "#F52D56" }}
                              />
                              {value}
                            </div>
                          ) : column.id === "delivery" ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <IoMdTime
                                style={{ fontSize: "18px", color: "#FF961F" }}
                              />

                              <span
                                style={{
                                  border: "1px solid rgb(168, 199, 231)",
                                  padding: "5px",
                                  borderRadius: "5px",
                                }}
                              >
                                {value}
                              </span>
                            </div>
                          ) : column.id === "typeofpack" ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              {value === "Bag" ? (
                                <FaBagShopping
                                  style={{ fontSize: "18px", color: "#FF961F" }}
                                />
                              ) : (
                                <FaBox
                                  style={{ fontSize: "18px", color: "#FF961F" }}
                                />
                              )}
                              {value}
                            </div>
                          ) : (
                            value
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
